import * as React from 'react'

const SvgArrowDownRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 16.25V15h7.869L3.75 4.631l.881-.881L15 14.119V6.25h1.25v10h-10z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowDownRightIcon
